import _ from 'underscore';
import { getRoutePathById, allSiteMap } from '@bingads-webui-react/with-site-map';

export const isCampaignEditorialPending
  = assetGroups => assetGroups.every(assetGroup => assetGroup.DeliveryStatus === 'EditorialUnderAppeal' || assetGroup.DeliveryStatus === 'EditorialPending');

export function statusAndActionReport({
  activity,
  type,
  status,
  details,
  action,
}) {
  const message = {
    type,
    action,
    status,
    details,
  };
  activity.trace(JSON.stringify(message));
}

export function auditPointDisplayed({
  activity,
  auditPoint,
  area,
}) {
  activity.trace(`Diagnostic card: display ${auditPoint} area:${area}`);
}

export function getFullProductUrl(routeName, scope, extraParams = []) {
  const baseParams = ['aid', 'cid', 'uid'];
  const params = baseParams.concat(extraParams);
  const pathname = getRoutePathById(allSiteMap, routeName);
  const search = params.reduce((result, param) => {
    const value = _.get(scope, ['values', param]);
    if (value != null) {
      return result.concat(`${param}=${value}`);
    }
    return result;
  }, []).join('&');

  return `${pathname}?${search}`;
}
